/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CHALLENGE_TYPES = ['word', 'phrase', 'idiom', 'chunk', 'phrasal_verb'] as const;

export const UNCLASSIFIED_CHALLENGE_TYPE = '';

export const QUOTE_CHALLENGE_TYPE = 'quote';

export const challengeTypeSchema = z.enum(CHALLENGE_TYPES);

export type IChallengeType = z.infer<typeof challengeTypeSchema>;
